export default __webpack_public_path__ + "static/media/LION.54bcdd0c.gif";